import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { User } from 'src/app/models';
import { SlingConfigService } from 'src/app/services/sling-config.service';
import { UserService } from 'src/app/services/user.service';
import { FormatUtil } from 'src/app/utils/format.util';
import { MessageUtil } from 'src/app/utils/message.util';

@Component({
  selector: 'app-user-marina-tab',
  templateUrl: './user-marina-tab.component.html',
  styleUrls: ['./user-marina-tab.component.scss']
})
export class UserMarinaTabComponent implements OnInit {

  @Output()
  eventsUser = new EventEmitter();

  numberOfRows = 10;
  users: User[] = [];
  usersTable: User[] = [];
  globalFilter = '';
  userStatus: boolean = null;

  constructor(
    private slingConfigService: SlingConfigService,
    private spinner: NgxSpinnerService,
    private userService: UserService,
    private messageUtil: MessageUtil
  ) { }

  ngOnInit(): void {
    this.loadSlingConfig();
    this.fillUsersTable();
  }

  private loadSlingConfig(): void {
    this.slingConfigService.getSlingConfig().subscribe(
      (data) => {
        const slingConfig = data[0];
        this.numberOfRows = (slingConfig && slingConfig.numberOfRecordsPerPage) ? slingConfig.numberOfRecordsPerPage : 10;
      },
      () => null
    );
  }

  filterGlobal(): void {
    this.usersTable = this.users.filter(
      (u) =>
        (u.firstName && (FormatUtil.getNotAccents(u.firstName).toUpperCase()
          .includes(FormatUtil.getNotAccents(this.globalFilter).toUpperCase()) ||
          u.firstName.toUpperCase().includes(this.globalFilter.toUpperCase()))
        ) ||
        (u.lastName && (FormatUtil.getNotAccents(u.lastName).toUpperCase()
          .includes(FormatUtil.getNotAccents(this.globalFilter).toUpperCase()) ||
          u.lastName.toUpperCase().includes(this.globalFilter.toUpperCase()))
        ) ||
        (u.email && u.email.toUpperCase().includes(this.globalFilter.toUpperCase())) ||
        (u.username && u.username.toUpperCase().includes(this.globalFilter.toUpperCase()))
    );
  }

  fillUsersTable(): void {
    this.spinner.show();
    this.userService.getMarinaUsersRoleFiltered().subscribe(
      (u) => {
        const usersWithoutCollaborator = u.filter((user) => user.roleId && user.roleId.name != "COLLABORATOR");
        this.users = usersWithoutCollaborator;
        this.usersTable = this.users;
        this.filterGlobal();
      },
      (error) => {
        const exception = error.error.data.exception;
        this.messageUtil.generateMessage(exception.type, exception.title, exception.message);
      },
      () => this.spinner.hide());
  }

  openUserFormDialog(idUser?: number): void {
    this.eventsUser.emit({ isDelete: false, user: idUser, origin: 'TabMarina' });
  }

  openUserDeleteConfirmDialog(idUser: number): void {
    this.eventsUser.emit({ isDelete: true, user: idUser, origin: 'TabApp' });
  }

  openUserAccessDialog(user: User): void {
    this.eventsUser.emit({ isAccess: true, user, origin: 'TabMarina' });
  }

  getRoleName(user: User): string {
    return user.roleId ? user.roleId.name : '';
  }
}
